export const RESET_INVENTORY_LOCATION_ISFETCHING =
  'RESET_INVENTORY_LOCATION_ISFETCHING';
export const LIST_INVENTORY_LOCATIONS_REQUEST =
  'LIST_INVENTORY_LOCATIONS_REQUEST';
export const INVENTORY_LOCATION_LIST_REQUESTING =
  'INVENTORY_LOCATION_LIST_REQUESTING';
export const LIST_INVENTORY_LOCATIONS_SUCCESS =
  'LIST_INVENTORY_LOCATIONS_SUCCESS';
